import { http } from '../../config/axios'

export default function getFaturaDownloadConsulta(id:string) :Promise<Blob>{
    return http.get('/api/fatura/imprimirconsulta/' + id, {
        responseType: 'blob'
    })
    .then((r) => r.data)
    .then((blobFile) => {
        return blobFile
    })
    .catch((error) => {
        console.error('Erro ao getFaturaDownloadConsulta')
        return new Blob()
    })
}